import { fetchAPI } from "../redux/api";

const read = async (response) => {
  if (!response.ok) {
    const body = await response.text();
    try { throw new Error(JSON.parse(body).message || body); }
    catch (error) { if (error instanceof SyntaxError) throw new Error(body || "Request failed."); throw error; }
  }
  if (response.status === 204) return null;
  const body = await response.text();
  return body ? JSON.parse(body) : null;
};

const restaurantId = () => JSON.parse(localStorage.getItem("admin_token_info") || "{}").restaurantId;

export const taxApi = {
  saveCategory: (payload) => fetchAPI(`tax-categories/${restaurantId()}`, payload, "POST").then(read),
  deleteCategory: (categoryId) => fetchAPI(`tax-categories/${restaurantId()}/${categoryId}`, null, "DELETE").then(read)
};
